<ng-container *transloco="let t; read: 'common.labels'">
  <span *ngIf="submitting !== true && icons === true">
    <button pButton *ngIf="cancelHidden !== true" (click)="onCancel()" type="button" [label]="cancelLabel || t('cancel')" class="p-button-outlined p-mb-2"></button>
    <button pButton type="submit" icon="pi pi-check" [label]="submitLabel || t('save')" class="p-button-primary p-mb-2 p-ml-2" [disabled]="(disabled) ? true : null" autofocus></button>
  </span>
  <span *ngIf="submitting === true && icons === true">
    <button pButton *ngIf="cancelHidden !== true" type="button" [label]="cancelLabel || t('cancel')" class="p-button-outlined p-mb-2" disabled="true"></button>
    <button pButton type="submit" [label]="submitLabel || t('save')" icon="pi pi-spin pi-spinner" class="p-button-primary p-mb-2 p-ml-2" disabled="true"></button>
  </span>
  <span *ngIf="submitting !== true && icons !== true">
    <button pButton *ngIf="cancelHidden !== true" (click)="onCancel()" type="button" icon="pi pi-times" class="p-button-outlined"></button>
    <button pButton type="submit" icon="pi pi-check" class="p-button-primary p-ml-2" [disabled]="(disabled) ? true : null" autofocus></button>
  </span>
  <span *ngIf="submitting === true && icons !== true">
    <button pButton *ngIf="cancelHidden !== true" type="button" icon="pi pi-times" class="p-button-outlined" disabled="true"></button>
    <button pButton type="submit" icon="pi pi-spin pi-spinner" class="p-button-primary p-ml-2" disabled="true"></button>
  </span>
</ng-container>
